import { createClient } from '@supabase/supabase-js';
 
const SUPABASE_URL = 'https://mywjuzpogvmdwuvbhsxb.supabase.co';
const SUPABASE_KEY = 'sb_publishable_VfiLFVQ9Ypqoj_T_tIBXKA_616WyIq4';
 
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
 
export async function fetchTeams() {
  const { data, error } = await supabase.from('v_team_cap').select('*').order('name');
  if (error) throw error;
  return data;
}
 
export async function fetchTeamRoster(teamId) {
  const { data, error } = await supabase.from('v_active_roster').select('*').eq('team_id', teamId).order('salary', { ascending: false });
  if (error) throw error;
  return data;
}
 
export async function fetchPlayer(playerId) {
  const [playerRes, txRes] = await Promise.all([
    supabase.from('v_active_roster').select('*').eq('id', playerId).single(),
    supabase.from('transactions').select('*').eq('player_id', playerId).order('date', { ascending: false }),
  ]);
  if (playerRes.error) throw playerRes.error;
  return { ...playerRes.data, transactions: txRes.data || [] };
}
 
export async function fetchPlayers({ pos, teamId, status, search } = {}) {
  let q = supabase.from('v_active_roster').select('*');
  if (pos)    q = q.eq('pos', pos);
  if (teamId) q = q.eq('team_id', teamId);
  if (status) q = q.eq('status', status);
  if (search) q = q.ilike('full_name', `%${search}%`);
  q = q.order('salary', { ascending: false });
  const { data, error } = await q;
  if (error) throw error;
  return data;
}
 
export async function fetchDraftPicks(teamId) {
  const { data, error } = await supabase.from('draft_picks').select('*').eq('owner_team', teamId).eq('used', false).order('draft_year').order('round');
  if (error) throw error;
  return data;
}
 
export async function fetchTransactions(limit = 50) {
  const { data, error } = await supabase.from('transactions').select('*, players(id, full_name, num, pos)').order('date', { ascending: false }).limit(limit);
  if (error) throw error;
  return data;
}